import { Ingrediente } from "../types/ingrediente.type";
import { Producto } from "../types/producto";
import ApiService from "./apiService";

const endpoint = "/api/v1/negocios/productos";

type ProductoBody = {
  titulo: string;
  descripcion: string;
  destacado: boolean;
  precio: number;
  imagen: string;
  categoriaId: number;
  ingredientes: Array<
    Pick<Ingrediente, "nombre" | "precio" | "disponible"> & { tipoIngredienteId: number }
  >;
  globales: number[];
};

class ProductosService extends ApiService {
  getOne(productoId: number) {
    return this.get<Producto>(`${endpoint}/${productoId}`, {
      negocioActivo: true,
    });
  }

  updateDisponible(productoId: number, disponible: boolean) {
    return this.put(
      `${endpoint}/${productoId}/disponible`,
      {
        disponible,
      },
      {
        negocioActivo: true,
      }
    );
  }

  create(producto: ProductoBody) {
    return this.post<Producto>(endpoint, producto, {
      negocioActivo: true,
    });
  }

  update(productoId: number, producto: ProductoBody) {
    return this.put<Producto>(`${endpoint}/${productoId}`, producto, {
      negocioActivo: true,
    });
  }

  delete(productoId: number) {
    return this.del(`${endpoint}/${productoId}`, {
      negocioActivo: true,
    });
  }
}

const productosService = new ProductosService();
export default productosService;
